import { useRole } from '../../contexts/RoleContext';

const safeHref = (url) => /^https?:\/\//i.test(url) ? url : '#';

const formatDate = (d) => {
  if (!d) return '';
  const [y, m, day] = d.split('-');
  return `${day}/${m}/${y}`;
};

const ShiftBlock = ({ period, periodEntries, ownEntry, userId, sickCollaborators = [], injuredCollaborators = [], expandedEntries, toggleExpand, onOpenAdd, onOpenEdit }) => {
  const { effectiveIsDirector: isDirector } = useRole();
  const canAdd = isDirector || !ownEntry;
  const handleHeaderClick = () => (canAdd ? onOpenAdd() : onOpenEdit(ownEntry));

  return (
    <div style={{ flex: 1, borderRadius: 8, overflow: 'hidden', border: '1px solid rgba(0,0,0,0.13)', boxShadow: '0 1px 4px rgba(0,0,0,0.07)', display: 'flex', flexDirection: 'column' }}>

      <div
        onClick={handleHeaderClick}
        style={{ background: period.bg, color: period.text, padding: '10px 14px', fontWeight: 700, fontSize: 14, cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', userSelect: 'none' }}
      >
        <span>{period.label}</span>
        {canAdd && <span style={{ fontSize: 22, lineHeight: 1, opacity: 0.9 }}>+</span>}
      </div>

      <div style={{ flex: 1 }}>
        {periodEntries.length === 0 ? (
          <div
            onClick={handleHeaderClick}
            style={{ padding: '18px 14px', color: '#aaa', fontSize: 13, fontStyle: 'italic', textAlign: 'center', cursor: 'pointer' }}
          >
            Nessuna descrizione — clicca per aggiungere
          </div>
        ) : (
          periodEntries.map((d, idx) => {
            const isExpanded = expandedEntries.has(d.id);
            const canEdit = isDirector || String(d.user_id) === String(userId);
            const needsExpand = d.testo && (d.testo.length > 220 || d.testo.split('\n').length > 4);
            const rowBg = idx % 2 === 0 ? '#fff' : '#f9f9f9';

            return (
              <div key={d.id} style={{ padding: '12px 14px', borderTop: idx === 0 ? 'none' : '1px solid #efefef', background: rowBg }}>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                  <strong style={{ fontSize: 13, color: '#222' }}>{d.nome} {d.cognome}</strong>
                  {canEdit && (
                    <button
                      onClick={e => { e.stopPropagation(); onOpenEdit(d); }}
                      style={{ background: 'none', border: `1px solid ${period.bg}`, color: period.bg, borderRadius: 4, padding: '2px 8px', fontSize: 12, cursor: 'pointer', lineHeight: 1.4 }}
                    >
                      Modifica
                    </button>
                  )}
                </div>

                <div style={{ position: 'relative' }}>
                  <div style={{ fontSize: 13, lineHeight: 1.6, color: '#333', whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: isExpanded ? 'none' : '6.4em', overflow: 'hidden' }}>
                    {d.testo}
                  </div>
                  {!isExpanded && needsExpand && (
                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '2.2em', background: `linear-gradient(transparent, ${rowBg})`, pointerEvents: 'none' }} />
                  )}
                </div>

                {needsExpand && (
                  <button
                    onClick={() => toggleExpand(d.id)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: period.bg, fontSize: 12, padding: '4px 0 0 0', fontWeight: 600 }}
                  >
                    {isExpanded ? '▲ Riduci' : '▼ Leggi tutto'}
                  </button>
                )}

                {d.attachments && d.attachments.length > 0 && (
                  <div style={{ marginTop: 8 }}>
                    {d.attachments.map(a => (
                      <a key={a.id} href={safeHref(a.file_url || a.url)} target="_blank" rel="noreferrer" style={{ display: 'block', fontSize: 12, color: period.bg, marginTop: 2 }}>
                        📎 {a.file_name || a.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>

      {canAdd && periodEntries.length > 0 && (
        <div
          onClick={onOpenAdd}
          style={{ borderTop: '1px solid #efefef', padding: '9px 14px', textAlign: 'center', fontSize: 12, fontWeight: 700, color: period.bg, cursor: 'pointer', background: '#fafafa', letterSpacing: 0.3 }}
        >
          + Aggiungi descrizione
        </div>
      )}

      {sickCollaborators.length > 0 && (
        <div style={{ borderTop: '1px solid #efefef', padding: '8px 14px', background: '#fff8f8' }}>
          {sickCollaborators.map((s, i) => (
            <div key={i} style={{ fontSize: 12, color: '#c0392b', padding: '2px 0' }}>
              🤒 {s.name} in malattia dal {formatDate(s.start_date)} al {formatDate(s.end_date)}
            </div>
          ))}
        </div>
      )}

      {injuredCollaborators.length > 0 && (
        <div style={{ borderTop: '1px solid #efefef', padding: '8px 14px', background: '#f2fbfa' }}>
          {injuredCollaborators.map((s, i) => (
            <div key={i} style={{ fontSize: 12, color: '#00767a', padding: '2px 0' }}>
              🤕 {s.name} in infortunio dal {formatDate(s.start_date)} al {formatDate(s.end_date)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ShiftBlock;
